import {useCallback, useEffect, useRef} from 'react';
import {Location} from 'react-router';

import {useAnalytics} from './useAnalytics';

/**
 * Hook to track page views with debouncing to prevent multiple rapid-fire events
 * @returns void
 */
export const useGTMPageView = (location: Location): void => {
  const {trackPageView, hasConsent, isInitialized} = useAnalytics();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedTrackPageView = useCallback(
    (path: string) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        trackPageView(path);
      }, 300);
    },
    [trackPageView]
  );

  useEffect(() => {
    if (hasConsent && isInitialized) {
      debouncedTrackPageView(location.pathname + location.search);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [location.pathname, location.search, hasConsent, isInitialized, debouncedTrackPageView]);
};
